import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import "./AllpilotsVehicleshistory.css";
import { fetchPilotDroneMissionHistory } from "../Apis/AdminApis";
import {
  FiFilter,
  FiSearch,
  FiCalendar,
  FiUser,
  FiCpu,
  FiClock,
  FiMapPin,
  FiBarChart2,
  FiChevronDown,
  FiChevronUp,
  FiChevronLeft,
  FiChevronRight,
  FiRefreshCw,
  FiX,
} from "react-icons/fi";

import {
  MdOutlineDateRange,
  MdOutlineViewWeek,
  MdOutlineCalendarViewMonth,
  MdOutlineCalendarToday,
} from "react-icons/md";
import pavamanLogo from "../images/drone.png";
import PopupMessage from "../PopupMessage/PopupMessage";

const PilotsVehicles = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pilotsData, setPilotsData] = useState([]);

  const [pilotPagination, setPilotPagination] = useState({
    current_page: 1,
    per_page: 5,
    total_pilots: 0,
    total_pages: 1
  });
  const [filterType, setFilterType] = useState("month");
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [expandedPilot, setExpandedPilot] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [viewMode, setViewMode] = useState("list");
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [activeFilterCount, setActiveFilterCount] = useState(0);
  const [missionsPerPage] = useState(5);
  const [pilotsCurrentPage, setPilotsCurrentPage] = useState(1);
  const [pilotsPerPage] = useState(5);
  const [isPilotPaginationLoading, setIsPilotPaginationLoading] = useState(false);
const [missionsPageMap, setMissionsPageMap] = useState({});
const [applyFilterTrigger, setApplyFilterTrigger] = useState(0);

const [popupOpen, setPopupOpen] = useState(false);
const [popupMessage, setPopupMessage] = useState("");
const [popupType, setPopupType] = useState("info");

useEffect(() => {
  const today = new Date();

  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  setSelectedDate(today.toISOString().split('T')[0]);
  setStartDate(startOfMonth.toISOString().split('T')[0]);
  setEndDate(today.toISOString().split('T')[0]);
}, []);

useEffect(() => {
  let count = 0;
  if (searchQuery) count++;
  setActiveFilterCount(count);
}, [searchQuery]);

useEffect(() => {
  setPilotsCurrentPage(1);
}, [searchQuery]);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

const handleMissionsPageChange = (pilotId, newPage, totalPages) => {
  if (newPage >= 1 && newPage <= totalPages) {
    setMissionsPageMap(prev => ({
      ...prev,
      [pilotId]: newPage
    }));
  }
};

const togglePilotDetails = (pilotId) => {
  setMissionsPageMap(prev => ({
    ...prev,
    [pilotId]: 1
  }));
  setExpandedPilot(expandedPilot === pilotId ? null : pilotId);
};

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      
const payload = {
        filter_type: filterType,
        date: filterType !== "custom" ? selectedDate : undefined,
        start_date: filterType === "custom" ? startDate : undefined,
        end_date: filterType === "custom" ? endDate : undefined,
        pilot_page: pilotsCurrentPage,
        pilots_per_page: pilotsPerPage,
        mission_page: missionsPageMap[expandedPilot] || 1,
        missions_per_page: missionsPerPage
      };
      
      const result = await fetchPilotDroneMissionHistory(payload);
      
     let pilotsList = [];
let paginationInfo = {};

if (result.type === "multi") {
  pilotsList = result.superadmin_company?.data || [];
  paginationInfo = result.superadmin_company?.pilot_pagination || {
    current_page: 1,
    per_page: pilotsPerPage,
    total_pilots: pilotsList.length,
    total_pages: 1
  };
} else {
  pilotsList = result.data || [];
  paginationInfo = result.pilot_pagination || {
    current_page: 1,
    per_page: pilotsPerPage,
    total_pilots: pilotsList.length,
    total_pages: 1
  };
} 
      let filteredPilots = pilotsList;
      if (searchQuery) {
        const query = searchQuery.trim().toLowerCase();
        filteredPilots = pilotsList.filter(pilot => 
          pilot.pilot_name?.toLowerCase().includes(query) ||
          pilot.email?.toLowerCase().includes(query) ||
          pilot.pilot_id?.toString().includes(query)
        );
      }
      
      setPilotsData(filteredPilots);
      setPilotPagination({
        current_page: paginationInfo.current_page || 1,
        per_page: paginationInfo.per_page || pilotsPerPage,
        total_pilots: paginationInfo.total_pilots || 0,
        total_pages: paginationInfo.total_pages || 1
      });
    } catch (err) {
      console.error("Failed to fetch data:", err);
      if (
  err?.response?.status === 401 ||
  err?.message?.includes("Unauthorized")
) {
  setPopupMessage("Session expired, redirecting to login page");
  setPopupType("error");
  setPopupOpen(true);

  setTimeout(() => {
    navigate("/login");
  }, 2000);

  return;
}
      setError("Failed to load pilot and vehicle data. Please try again.");
    } finally {
      setIsLoading(false);
      setIsPilotPaginationLoading(false);
    }
  }, [applyFilterTrigger, pilotsCurrentPage, missionsPageMap, expandedPilot, searchQuery]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

const handleResetFilters = () => {
  const today = new Date();
  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  setSearchQuery("");

  setFilterType("month");

  setSelectedDate(today.toISOString().split("T")[0]);

  setStartDate(startOfMonth.toISOString().split("T")[0]);
  setEndDate(today.toISOString().split("T")[0]);

  setPilotsCurrentPage(1);
  setExpandedPilot(null);
  setMissionsPageMap({});

  setApplyFilterTrigger(prev => prev + 1);
};

  const handlePilotPageChange = (newPage) => {
    const totalPages = pilotPagination.total_pages;
    if (newPage >= 1 && newPage <= totalPages) {
      setIsPilotPaginationLoading(true);
      setPilotsCurrentPage(newPage);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const toggleFilters = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  if (isLoading && pilotsData.length === 0) {
    return (
      <div className="dashboard-wrapper">
        <Sidebar />
        <div className="dashboard-content">
          <div className="custom-loading-container">
            <img
              src={pavamanLogo}
              alt="Loading"
              className="spinning-logo"
            />
            <p className="loading-text">
              Loading Pilots & Vehicles data...
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-wrapper">
      <Sidebar />
      <PopupMessage
  isOpen={popupOpen}
  onClose={() => setPopupOpen(false)}
  message={popupMessage}
  type={popupType}
/>
      <div className="dashboard-content">
        <div className="dashboard-header">
          <div className="header-left">
            <h1 className="dashboard-title">Pilots & Vehicles</h1>
            <p className="dashboard-subtitle">Track pilot performance and drone utilization in real-time</p>
          </div>
          
          <div className="header-right">
            <button 
              className="filter-toggle-btn"
              onClick={toggleFilters}
            >
              <FiFilter size={18} />
              {isFilterVisible ? "Hide Filters" : "Show Filters"}
            </button>
          </div>
        </div>

        {isFilterVisible && (
          <div className="filters-section-flights">
            <div className="filters-grid">
              <div className="filter-group">
                <label>Start Date</label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="filter-input"
                />
              </div>
              <div className="filter-group">
                <label>End Date</label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="filter-input"
                />
              </div>
            </div>
            <div className="filter-actions">
              <button 
                className="apply-filters-btn" 
 onClick={() => {
  if (!startDate || !endDate) {
    alert("Please select start and end date");
    return;
  }

  if (startDate > endDate) {
    alert("Start Date cannot be greater than End Date");
    return;
  }

  setFilterType("custom");
  setPilotsCurrentPage(1);
  setExpandedPilot(null);
  setMissionsPageMap({});
  setApplyFilterTrigger(prev => prev + 1);
}}
                disabled={isLoading}
              >
                 {isLoading ? "Applying..." : "Apply Filters"}
              </button>
              <button className="reset-filters-btn" onClick={handleResetFilters}>
                Reset
              </button>
            </div>
          </div>
        )}

<div className="default-filter-info">
  {filterType === "custom" ? (
    startDate &&
    endDate && (
      <span>
        📅 Showing pilot history from {startDate} to {endDate}
      </span>
    )
  ) : (
    <span>
      📅 Current month data is being displayed by default. Use filters to view a different date range.
    </span>
  )}
</div>

          <div className="pv-search-bar">
            <FiSearch className="pv-search-icon" />
            <input
              type="text"
              placeholder="Search by pilot name, email..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="pv-search-input"
            />
            {searchQuery && (
              <button className="pv-clear-search" onClick={() => setSearchQuery("")}>
                <FiX size={18} />
              </button>
            )}
          </div>

        {error && (
          <div className="pv-error-message-modern">
            <span className="pv-error-icon">⚠️</span>
            <span className="pv-error-text">{error}</span>
            <button 
              className="pv-error-retry-btn"
              onClick={fetchData}
            >
              <FiRefreshCw size={16} />
              Retry
            </button>
          </div>
        )}

        <div className="pv-main-content-modern">
          <div className="pv-content-header-modern">
            <div className="pv-content-title-section">
              <h3 className="pv-content-title">
                Pilot Performance
                <span className="pv-pilot-count">{pilotsData.length} pilots</span>
              </h3>
            </div>
          </div>
          
          {pilotsData.length === 0 ? (
            <div className="pv-no-data-modern">
              <div className="pv-no-data-icon">📊</div>
              <h4 className="pv-no-data-title">No pilots found</h4>
              <p className="pv-no-data-text">
                {searchQuery 
                  ? "Try adjusting your filters or search query"
                  : "No pilot data available for the selected period"}
              </p>
              {searchQuery && (
                <button 
                  className="pv-no-data-reset-btn"
                  onClick={handleResetFilters}
                >
                  Clear Filters
                </button>
              )}
            </div>
          ) : (
            <>
              <div className="pv-pilots-list-modern">
                {pilotsData.map((pilot) => {
                 const totalMissionPages = pilot.missions_pagination?.total_pages || 1;
const currentPage = missionsPageMap[pilot.pilot_id] || 1;
const currentMissions = pilot.missions || [];
                  
                  return (
                    <div 
                      key={pilot.pilot_id} 
                      className={`pv-pilot-card-modern ${expandedPilot === pilot.pilot_id ? "expanded" : ""}`}
                    >
                      <div 
                        className="pv-pilot-card-header-modern"
                        onClick={() => togglePilotDetails(pilot.pilot_id)}
                      >
                        <div className="pv-pilot-info-wrapper">
                          <div className="pv-pilot-avatar-modern">
                            {pilot.pilot_name?.charAt(0) || "P"}
                          </div>
                          <div className="pv-pilot-details-modern">
                            <h4 className="pv-pilot-name-modern">{pilot.pilot_name}</h4>
                            <span className="pv-pilot-email-modern">{pilot.email}</span>
                          </div>
                        </div>
                        
                        <div className="pv-pilot-stats-modern">
                          <div className="pv-pilot-stat-item">
                            <span className="pv-pilot-stat-value">{pilot.total_missions || 0}</span>
                            <span className="pv-pilot-stat-label">Missions</span>
                          </div>
                          <div className="pv-pilot-stat-item">
                            <span className="pv-pilot-stat-value">{(pilot.total_flight_hours || 0).toFixed(2)}</span>
                            <span className="pv-pilot-stat-label">Hours</span>
                          </div>
                          <div className="pv-pilot-stat-item">
                            <span className="pv-pilot-stat-value">{(pilot.total_acres || 0).toFixed(2)}</span>
                            <span className="pv-pilot-stat-label">Acres</span>
                          </div>
                        </div>
                        
                        <button className="pv-expand-btn-modern">
                          {expandedPilot === pilot.pilot_id ? <FiChevronUp size={20} /> : <FiChevronDown size={20} />}
                        </button>
                      </div>

                      {expandedPilot === pilot.pilot_id && (
                        <div className="pv-pilot-details-expanded">
                          {(pilot.missions || []).length > 0 && (
                            <div className="pv-missions-section-modern">
                              <h5 className="pv-missions-title">
                                Recent Missions
                              </h5>
                              <div className="tr-table-container">
                                <table className="tr-table">
                                  <thead className="tr-thead">
                                    <tr>
                                      <th>Mission ID</th>
                                      <th>Date</th>
                                      <th>Vehicle ID</th>
                                      <th>Hours</th>
                                      <th>Acres</th>
                                      <th>Spray Status</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {currentMissions.map((mission, index) => (
                                      <tr key={index}>
                                        <td>
                                          <span className="pv-mission-id-badge">
                                            {mission.mission_id || 'N/A'}
                                          </span>
                                        </td>
                                        <td>{formatDate(mission.mission_date)}</td>
                                        <td>
                                          <span className="pv-drone-badge-modern">
                                            {mission.drone_id || 'N/A'}
                                          </span>
                                        </td>
                                        <td>{mission.flight_hours?.toFixed(2) || '0.00'}</td>
                                        <td>{mission.total_acres?.toFixed(2) || '0.00'}</td>
                                        <td>
                                          <span className={`pv-spray-badge ${mission.spray_status === "sprayed" ? 'pv-sprayed' : 'pv-not-sprayed'}`}>
  {mission.spray_status === "sprayed" ? '✓ Sprayed' : '✗ Not Sprayed'}
</span>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>

                              {totalMissionPages > 1 && (
                                <div className="pagination-container">
                                  <div className="pagination-controls">
                                    <button
                                      className="pagination-btn"
                                      onClick={() => handleMissionsPageChange(pilot.pilot_id, currentPage - 1, totalMissionPages)}
                                      disabled={currentPage === 1}
                                    >
                                      ← Previous
                                    </button>
                                    
                                    <div className="page-numbers">
                                      {Array.from({ length: Math.min(5, totalMissionPages) }, (_, i) => {
                                        let pageNumber;
                                        if (totalMissionPages <= 5) {
                                          pageNumber = i + 1;
                                        } else if (currentPage <= 3) {
                                          pageNumber = i + 1;
                                        } else if (currentPage >= totalMissionPages - 2) {
                                          pageNumber = totalMissionPages - 4 + i;
                                        } else {
                                          pageNumber = currentPage - 2 + i;
                                        }
                                        
                                        return (
                                          <button
                                            key={pageNumber}
                                            className={`page-btn ${currentPage === pageNumber ? 'active' : ''}`}
                                            onClick={() => handleMissionsPageChange(pilot.pilot_id, pageNumber, totalMissionPages)}
                                          >
                                            {pageNumber}
                                          </button>
                                        );
                                      })}
                                    </div>
                                    
                                    <button
                                      className="pagination-btn"
                                      onClick={() => handleMissionsPageChange(pilot.pilot_id, currentPage + 1, totalMissionPages)}
                                      disabled={currentPage === totalMissionPages}
                                    >
                                      Next →
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
  
              {pilotPagination.total_pages > 1 && (
                <div className="pv-pilot-pagination-wrapper">
                  <div className="pv-pilot-pagination-controls">
                    <button
                      className="pv-pilot-pagination-btn"
                      onClick={() => handlePilotPageChange(pilotsCurrentPage - 1)}
                      disabled={pilotsCurrentPage === 1 || isPilotPaginationLoading}
                    >
                      <FiChevronLeft size={16} />
                      Previous
                    </button>
                    
                    <div className="pv-pilot-page-numbers">
                      {Array.from({ length: Math.min(5, pilotPagination.total_pages) }, (_, i) => {
                        let pageNumber;
                        if (pilotPagination.total_pages <= 5) {
                          pageNumber = i + 1;
                        } else if (pilotsCurrentPage <= 3) {
                          pageNumber = i + 1;
                        } else if (pilotsCurrentPage >= pilotPagination.total_pages - 2) {
                          pageNumber = pilotPagination.total_pages - 4 + i;
                        } else {
                          pageNumber = pilotsCurrentPage - 2 + i;
                        }
                        
                        return (
                          <button
                            key={pageNumber}
                            className={`pv-pilot-page-btn ${pilotsCurrentPage === pageNumber ? 'pv-pilot-active' : ''}`}
                            onClick={() => handlePilotPageChange(pageNumber)}
                            disabled={isPilotPaginationLoading}
                          >
                            {pageNumber}
                          </button>
                        );
                      })}
                    </div>
                    
                    <button
                      className="pv-pilot-pagination-btn"
                      onClick={() => handlePilotPageChange(pilotsCurrentPage + 1)}
                      disabled={pilotsCurrentPage === pilotPagination.total_pages || isPilotPaginationLoading}
                    >
                      Next
                      <FiChevronRight size={16} />
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PilotsVehicles;